export default "__VITE_ASSET__ByQ4Y78A__"